import React from 'react';

const stockLogos = [
  'AAPL', 'NVDA', 'TSLA', 'MSFT', 'GOOGL', 'META', 'AMZN', 'NFLX',
  'JPM', 'V', 'MA', 'COIN', 'HOOD', 'SPY', 'QQQ', 'BAC'
];

const InvestingForEveryone = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#0b0014] via-[#10051f] to-[#0b0014] relative overflow-hidden">
      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(123, 97, 255, 0.3) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Glowing orbs */}
      <div className="absolute top-20 right-1/4 w-[300px] h-[300px] bg-purple-500/20 rounded-full blur-[100px] animate-pulse" />
      <div className="absolute bottom-20 left-1/4 w-[250px] h-[250px] bg-indigo-500/15 rounded-full blur-[80px] animate-pulse" style={{ animationDelay: '1s' }} />
      
      <div className="max-w-[1000px] mx-auto px-6 relative">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8">
            Global Markets,<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-indigo-400">
              On-Chain.
            </span>
          </h2>
          
          <div className="max-w-2xl mx-auto space-y-6">
            <p className="text-xl text-gray-300 leading-relaxed">
              Traditional stock markets are siloed, slow, and limited by borders. Blockchain changes everything.
            </p>
            <p className="text-2xl text-white font-medium">
              Stocks Protocol brings Wall Street to the world — 24/7, borderless, and truly yours.
            </p>
          </div>
          
          {/* Token Grid Illustration with Stock Logos */}
          <div className="mt-16 relative">
            <div className="grid grid-cols-4 md:grid-cols-8 gap-3 max-w-2xl mx-auto">
              {stockLogos.map((stock, i) => (
                <div 
                  key={i}
                  className="group aspect-square rounded-xl bg-gradient-to-br from-white/[0.08] to-white/[0.02] border border-white/10 flex items-center justify-center hover:border-purple-500/50 hover:scale-110 hover:bg-white/[0.12] transition-all duration-300 cursor-pointer overflow-hidden"
                  style={{ animationDelay: `${i * 0.05}s` }}
                >
                  <img 
                    src={`https://assets-sir.kraken.com/equities/logos/v1/${stock}.png?i=kds`}
                    alt={stock}
                    className="w-8 h-8 md:w-10 md:h-10 object-contain opacity-70 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
            
            {/* Glow effect under grid */}
            <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-[400px] h-[100px] bg-purple-500/30 rounded-full blur-[60px]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestingForEveryone;
